<template>
  <div class="flex flex_col sqm-page">
    <!-- 上面的下拉选择 -->
    <div class="flex flex_a_c sf-selects">
      <img class="sf_icon" src="@/assets/image/sq/icon_small.png" alt="" />
      <el-form
        class="sf-form warnform-inline"
        :inline="true"
        ref="selectForm"
        :model="selectForm"
      >
        <el-form-item
          label="选择生产区域"
          style="margin-bottom: 0"
          v-if="isShowAllSelect"
        >
          <el-select
            v-model="allOrgId"
            :placeholder="orgAllSelect.length ? '请选择' : '暂无设备'"
            @change="changeAllOrg"
          >
            <el-option
              v-for="(item, index) in orgAllSelect"
              :key="index"
              :value="item.orgId"
              :label="item.orgName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="isShowAllSelect ? '' : '选择墒情监测站点'">
          <el-select
            v-model="selectForm.facId"
            @change="changeOrg"
            :placeholder="orgSelect.length ? '请选择' : '暂无设备'"
          >
            <el-option
              v-for="(item, index) in orgSelect"
              :key="index"
              :value="item.facId"
              :label="item.facName"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <!-- 下面的内容数据 -->
    <div class="flex flex_col page-content" v-loading="loading">
      <div class="page-top">
        <title-model titles="墒情实时监测">
          <div
            class="font_14 c_six"
            v-if="!isWarn && isInfoList && isorgSelect"
          >
            采集时间：{{ infoData.dataTime }}
          </div>
          <!-- 设备异常 -->
          <div
            class="flex flex_a_c"
            v-if="isorgSelect && (isWarn || !isInfoList)"
          >
            <img
              class="icon_warn"
              src="@/assets/image/home/icon_warn.png"
              alt=""
            />
            <span class="font_14 c_six">设备异常！</span>
          </div>
        </title-model>
        <!-- 上面的状态 -->
        <div class="flex">
          <img class="icon_big" src="@/assets/image/sq/icon_big.png" alt="" />
          <!-- 右边指令状态 -->
          <div class="sf-right">
            <div class="flex flex_a_c sq-wrap">
              <!-- 大图标：没有实时数据，且没有下拉选时显示 -->
              <!-- 
								1. 有墒情设备，没有右侧 ec,ph,氮磷钾数据
							 -->
              <template v-if="isorgSelect">
                <img
                  class="sq_img_big"
                  v-if="
                    isorgSelect &&
                    (!trEc.length || trEc == '--') &&
                    (!trPh.length || trPh == '--') &&
                    (isInfoList || cengData.length)
                  "
                  src="@/assets/image/sq/sq_img_big.png"
                  alt=""
                />
                <!-- 小图标 -->
                <img
                  class="sq_img"
                  v-else
                  src="@/assets/image/sq/sq_img.png"
                  alt=""
                />
              </template>

              <!-- 土壤层级 -->
              <ul class="flex flex_col flex_ju_sa sq_ceng" v-if="trWd.length">
                <li
                  class="flex flex_a_c ceng-li"
                  v-for="(item, index) in trWd"
                  :key="index"
                >
                  <img
                    class="img_line"
                    src="@/assets/image/sq/img_line.png"
                    alt=""
                  />
                  <div class="font_16 c_45 flex flex_a_c">
                    <span class="ceng-name font_16"
                      >第{{ changeNumToHan(index + 1) }}层:
                    </span>
                    <div class="flex flex_a_c font_16">
                      <img
                        class="ceng-icon"
                        src="@/assets/image/sq/icon_wd.png"
                        alt=""
                      />
                      <span class="font_16 ceng-tw"
                        >{{ item.name }}: {{ item.value
                        }}{{ item.unitName }}</span
                      >
                      <img
                        class="ceng-icon"
                        src="@/assets/image/sq/icon_ts.png"
                        alt=""
                      />
                      <span class="font_16 ceng-ts"
                        >{{ trSd[index].name }}: {{ trSd[index].value
                        }}{{ trSd[index].unitName }}</span
                      >
                    </div>
                  </div>
                </li>
              </ul>
              <!-- 没有数据且没有下拉选时显示 -->
              <div
                class="table-empty bottom-empty table-empty-small t_c"
                style="flex: 1"
                v-if="isorgSelect && !isInfoList && !cengData.length"
              >
                <img
                  class="table-noimg"
                  src="@/assets/image/home/img_none.png"
                  alt=""
                />
                <div class="table-emptyword">
                  <span>暂无数据</span>
                </div>
              </div>
              <!-- 没有墒情设备时显示 -->
              <div
                class="table-empty bottom-empty table-empty-big t_c"
                style="flex: 1"
                v-if="!isorgSelect"
              >
                <img
                  class="table-noimg"
                  src="@/assets/image/sf/empty.png"
                  alt=""
                />
                <div class="table-emptyword">
                  <span>该网点暂无墒情设备!</span>
                </div>
              </div>
              <!-- 其余的各个值 -->
              <div
                class="sq-others"
                v-if="
                  (trPh.length && trPh != '--') || (trEc.length && trEc != '--')
                "
              >
                <!-- EC和PH值 -->
                <div class="flex other-lis">
                  <div class="flex flex_ju_c flex_a_c other-div">
                    <img
                      class="sq_img"
                      src="@/assets/image/sq/icon_ec.png"
                      alt=""
                    />
                    <div class="other-values">
                      <div class="font_18 other-nums">
                        {{ trEc || "--" }}us/cm
                      </div>
                      <div class="font_14 other-name">EC值</div>
                    </div>
                  </div>
                  <div class="flex flex_ju_c flex_a_c other-div other-ph">
                    <img
                      class="sq_img"
                      src="@/assets/image/sq/icon_ph.png"
                      alt=""
                    />
                    <div class="other-values">
                      <div class="font_18 other-nums">
                        {{ trPh }}
                      </div>
                      <div class="font_14 other-name">PH值</div>
                    </div>
                  </div>
                </div>
                <!-- 氮磷钾 -->
                <div class="other-pies">
                  <div class="pie-chart pie-dan" ref="pieDan">
                    <div class="num">{{ trDlz }}</div>
                    <div class="unit">mg/kg</div>
                    <div class="name">氮离子</div>
                  </div>
                  <div class="pie-chart pie-lin" ref="pieLin">
                    <div class="num">{{ trLlz }}</div>
                    <div class="unit">mg/kg</div>
                    <div class="name">磷离子</div>
                  </div>
                  <div class="pie-chart pie-jia" ref="pieJia">
                    <div class="num">{{ trJlz }}</div>
                    <div class="unit">mg/kg</div>
                    <div class="name">钾离子</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 墒情统计数据 -->
      <div class="page-bottom" v-show="orgSelect.length && cengData.length">
        <title-model titles="墒情统计数据">
          <!-- 右侧的表单 -->
          <div class="right-form">
            <el-form
              :model="queryParam"
              :inline="true"
              ref="ruleForm"
              class="qxb-form warnform-inline"
            >
              <el-form-item label="">
                <el-select placeholder="请选择" v-model="queryParam.listparam">
                  <el-option
                    v-for="(item, index) in cengData"
                    :key="index"
                    :label="'第' + changeNumToHan(index + 1) + '层'"
                    :value="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="" class="form-picker">
                <div class="picker-divs picker-divs-more">
                  <el-date-picker
                    v-model="queryParam.startTime"
                    size="small"
                    type="datetime"
                    placeholder="选择日期"
                    popper-class="pick-poper"
                    class="picker-div"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    prefix-icon=" "
                    clear-icon="el-icon-date"
                    :clearable="false"
                    :picker-options="pickerOptions0"
                    :editable="false"
                  >
                  </el-date-picker>
                  <i class="pick-icon el-icon-date"></i>
                  <i class="pick-icon-yuan el-icon-time"></i>
                </div>

                <span class="pick-word">至</span>
                <div class="picker-divs picker-divs-more">
                  <el-date-picker
                    v-model="queryParam.endTime"
                    size="small"
                    type="datetime"
                    placeholder="选择日期"
                    popper-class="pick-poper"
                    class="picker-div"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    prefix-icon=" "
                    clear-icon="el-icon-date"
                    :clearable="false"
                    :picker-options="pickerOptions1"
                    :editable="false"
                  >
                  </el-date-picker>
                  <i class="pick-icon el-icon-date"></i>
                  <i class="pick-icon-yuan el-icon-time"></i>
                </div>
              </el-form-item>
              <el-form-item class="form-btns">
                <el-button type="primary" @click="searchTap">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
        </title-model>
        <!-- 气象折线图 -->
        <div class="qx-charts" ref="qxChartRef" v-show="isShowLine"></div>
        <div
          class="table-empty qx-charts flex flex_col flex_a_c flex_ju_c"
          v-show="!isShowLine"
        >
          <img
            class="table-noimg"
            src="@/assets/image/home/img_none.png"
            alt=""
          />
          <div
            class="table-emptyword"
            style="color: #797979; font-size: 0.17rem"
          >
            暂无墒情数据
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @description 墒情监测
 */
import titleModel from "@/components/title-model.vue";
import tableMinin from "@/mixins/TableMinin";
import shangqingJs from "./lib/shangq";
import {
  todayTime,
  GetPreMonthDay,
  GetNextMonthDay,
  getFormatDate,
} from "../../times/moment";
export default {
  components: { titleModel },
  mixins: [tableMinin, shangqingJs],
  data() {
    return {
      // 时间是否初始化
      isMakeTime: false,
      isShowLine: true,
      orgAllSelect: [], // 生产区域下拉选
      allOrgId: "", /// 分公司下面选中的orgid

      // 上面的监测站点选择表单
      orgSelect: [], // 上面的下拉选数据
      isorgSelect: true, // 是否有墒情设备
      selectForm: {
        facId: "",
      },
      infoData: {}, // 详情数据
      infoList: [], // 详情列表数据
      isInfoList: true, // 是否有实时数据
      trWd: [],
      trSd: [],
      isWarn: false, // 是否时异常状态
      // 采集项下拉选
      cengData: [],
      trEc: "",
      trPh: "",
      trDlz: "",
      trLlz: "",
      trJlz: "",
      twData: [],
      tsData: [],
      url: {
        lineChart: "/napi/index/soilMoistureDataChart",
      },
      // 折线图土壤层数
      chartToCeng: null,
      pickerOptions0: {
        disabledDate: (time) => {
          if (this.queryParam.endTime) {
            if (this.queryParam.endTime != "") {
              let num = new Date(this.queryParam.endTime).getTime();
              return time.getTime() > num;
            } else {
            }
          } else {
            return false;
          }
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          let num = new Date().getTime();
          if (time.getTime() > num) {
            return true;
          } else {
            let startNum =
              new Date(this.queryParam.startTime).getTime() - 43200000;
            if (time.getTime() < startNum) {
              return true;
            } else {
              return false;
            }
          }
        },
      },
    };
  },

  mounted() {
    // this.$set(this.queryParam, 'listparam', '0')
    this.$set(this.queryParam, "startTime", `${todayTime()} 00:00:00`);
    this.$set(this.queryParam, "endTime", `${todayTime()} 23:59:59`);
    // 获取头部下拉选数据
    // this.getOrgids()
    if (this.isShowAllSelect) {
      // 获取上面的生产区域信息
      this.getAllOrgids();
    } else {
      this.getOrgids();
    }

    // 获取折线图数据
    // this.getLineData()
    // this.lineChart()
    // this.$nextTick(() => {
    // 	this.makeDanPie()
    // 	this.makeLinPie()
    // 	this.makeJiaPie()
    // })
    // this.pieChart()
  },
};
</script>
<style lang="scss" scoped>
@mixin scrolls() {
  overflow-y: scroll;
  // 背景
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: transparent;
    border-radius: 4px;
  }
  // 背景
  &::-webkit-scrollbar-track {
    width: 8px;
    height: 8px;
    background-color: transparent;
    border-radius: 4px;
  }
  // 滚动条
  &::-webkit-scrollbar-thumb {
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background-color: #d9d9d9;
  }
}
.sqm-page {
  height: 100%;
  min-height: 670px;
  // 下拉选
  .sf-selects {
    margin-bottom: 0.13rem;
    .sf_icon {
      width: 0.25rem;
      height: 0.34rem;
    }
    .sf-form {
      display: inline-block;
      padding-left: 0;
      margin-left: 0.21rem;
    }
  }
  .page-content {
    flex: 1;
  }
  // 上面:气象实时监测
  .page-top {
    background: #ffffff;
    border-radius: 0.19rem;
    padding: 0 0.04rem;
    .icon_warn {
      width: 0.25rem;
      margin-right: 0.13rem;
    }
  }
  // 左边
  .icon_big {
    width: 1.91rem;
    margin: auto 0.91rem;
  }
  // 右边
  .sf-right {
    flex: 1;
    // 右边层数数据
    .sq-wrap {
      padding: 0.25rem 0 0.33rem;
      text-align: left;
      .sq_img {
        width: 5.44rem;
        height: 3.48rem;
      }
      .sq_ceng {
        margin-left: -0.96rem;
        height: 3.48rem;
        .img_line {
          width: 1.48rem;
          height: 0.13rem;
          margin-right: 0.12rem;
        }
        .ceng-name {
          color: #2daea9;
        }
        .ceng-icon {
          height: 0.35rem;
          margin: 0 0.13rem;
        }
      }
      .sq_img_big {
        height: 3.48rem;
      }
      // 右边的值
      .sq-others {
        margin-left: 0.21rem;
        .other-lis {
          .other-div {
            width: 2.5rem;
            height: 1.16rem;
            background: #f8f8f8;
            border: 1px solid #f1f1f1;
          }
          .other-ph {
            margin-left: 0.2rem;
          }
          .sq_img {
            width: 0.56rem;
            height: 0.56rem;
            margin-right: 0.19rem;
          }
          .sq_img_big {
            width: 9.5rem;
            height: 0.56rem;
            margin-right: 0.19rem;
          }
          .other-nums {
            color: #333333;
          }
          .other-name {
            color: #9a9a9a;
            margin-top: 0.13rem;
          }
        }
        // 环形图
        .other-pies {
          margin-top: 0.25rem;
          display: flex;
          justify-content: space-between;
          .pie-chart {
            // display: inline-block;
            width: 1.5rem;
            height: 1.5rem;
            // flex: 1;
            font-size: 0.25rem;
            position: relative;
            background: pink;
            // &:nth-child(2) {
            //   margin: 0 0.18rem;
            // }
            .num {
              margin-top: 0.5rem;
              font-size: 0.325rem;
              text-align: center;
            }
            .unit {
              text-align: center;
            }
            .name {
              color: black;
              position: absolute;
              left: 50%;
              bottom: -0.3125rem;
              transform: translateX(-50%);
            }
          }
          .pie-dan {
            color: #ffa21b;
            background: url("../../assets/image/sq/dan.png") no-repeat;
          }
          .pie-lin {
            color: #17a1c9;
            background: url("../../assets/image/sq/lin.png") no-repeat;
          }
          .pie-jia {
            color: #11a741;
            background: url("../../assets/image/sq/jia.png") no-repeat;
          }
        }
      }
    }
    // 缺省图
    .table-empty {
      margin-top: 0.29rem;
      //   padding-bottom: 0.587rem;
      .table-noimg {
        width: 4.1rem;
        height: 2.27rem;
      }
      .table-emptyword {
        margin-left: 0;
        margin-top: 0.75rem;
      }
    }
    .table-empty-small {
      .table-noimg {
        height: 2.27rem;
        width: auto;
      }
      .table-emptyword {
        color: #797979;
        font-size: 0.23rem;
        margin-top: 0.4rem;
      }
    }
  }
  // 下面
  .page-bottom {
    background: #ffffff;
    border-radius: 0.19rem;
    margin-top: 0.17rem;
    flex: 1;
    padding: 0 0.04rem 0;
    // 折线图
    .qx-charts {
      width: 100%;
      height: 82%;
    }
    .table-empty {
      .table-noimg {
        width: 2.35rem;
      }
    }
    // 表单
    .qxb-form {
      padding: 0;
      .form-picker {
        margin: 0 0.71rem 0 0.44rem;
      }
    }
  }
}
</style>
